export enum CheckboxSize {
    SM = 'SM',
    MD = 'MD'
}

export enum CheckboxStyle {
    SQUARE = 'SQUARE',
    CIRCLE = 'CIRCLE'
}